module.exports = __webpack_public_path__ + "img/logo.fafb1a0f.png";